import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from './FormField';

const required = value => value ? undefined : 'Required';
const requiredTerms = value =>
  value ? undefined : 'Accept Terms and Conditions to continue.';

const containsEmail = (...props) => {
  const { email } = props[1] || {};
  return !email.includes('@') || !email.includes('.')
    ? 'Please provide a valide email address.'
    : undefined;
};

const StayInLoopForm = (
  {
    handleSubmit,
    submitting,
    postError,
    result
  }
) => {
  return (
    <div>
      {postError &&
        <p className="loop-error">
          There was a problem with your submission, please try again.
        </p>}
      <form
        className="newsletterForm"
        name="subscribeForm"
        onSubmit={handleSubmit}
        id="subscribeForm"
      >
        <div className="form-row">
          <div className="col-12 col-sm-7">
            <Field
              name="email"
              type="text"
              component={FormField.Input}
              placeholder="Email Address"
              validate={[required, containsEmail]}
            />
            <div className="form-check terms-check">
              <Field
                required
                name="doesAgree"
                type="checkbox"
                component={FormField.InlineCheckbox}
                label={
                  <em>
                    I agree to the
                    {' '}
                    <a href="/privacy/"> Terms & Conditions</a>
                  </em>
                }
                normalize={value => !!value}
                validate={[requiredTerms]}
              />
            </div>
          </div>
          <div className="col-12 col-sm-5 col-lg-4">
            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={submitting}
            >
              Subscribe
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'stay-in-loop-form'
})(StayInLoopForm);
